module.exports = __webpack_public_path__ + "img/ic_2.f5cb152d.png";